@if (isModal) {
  @if (isModal) {
    <div class="modal-header" style="background-color: lightgray">
      <h4 class="modal-title">Receipt</h4>
      <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
    </div>
  }
}
@if (receipt !== undefined) {
  <div class="card shadow-lg m-0" [ngClass]="{ unsubmitCard: receipt.Valid == false }">
    <div class="card-body">
      <div class="row">
        <div class="col-10">
          <div>
            @if (adminView) {
              <button class="btn" [ngClass]="receipt.Saved ? 'btn-dark' : 'btn-light'" (click)="checkOpenBookmark()"><i [ngClass]="receipt.Saved ? 'fas' : 'far'" class="fa-bookmark"></i></button>
            }
            @if (receipt.CompanyCode !== undefined) {
              <span class="badge text-bg-dark ms-1">{{ receipt.CompanyCode }}</span>
            }
          </div>
          <h3>
            #{{ receipt.ID }} - {{ receipt.Name }}

            @if (adminView && receipt.Valid === true) {
              <span class="badge text-bg-success">Valid</span>
            } @else if (receipt.Valid == false && receipt.CheckedBy != undefined) {
              <span class="badge text-bg-danger">Invalid</span>
            } @else if (adminView && receipt.Valid == undefined) {
              <span class="badge text-bg-primary">Pending</span>
            }
          </h3>
        </div>
        <div class="col-2 d-flex justify-content-end align-items-end">
          <button class="btn btn-info" (click)="viewSetFiles()" #tooltip="matTooltip" matTooltip="View Files" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i class="fas fa-image"></i></button>
          @if (receipt.Valid === false && sharedService.isBranchManager()) {
            <button class="btn btn-secondary ms-1" (click)="openAddTransactionToSetModal()" #tooltip="matTooltip" matTooltip="Add transaction" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i class="fas fa-plus"></i></button>
            <button class="btn btn-danger ms-1" (click)="deleteAllTransactions()" #tooltip="matTooltip" matTooltip="Remove all transactions from set" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i class="fas fa-trash"></i></button>
          }
        </div>
      </div>

      <div class="text-secondary fw-bold">
        @if (isEditing) {
          <div class="form-floating my-2">
            <input class="form-control" type="text" name="editedRemark" id="editedRemark" placeholder="Remark" [(ngModel)]="editedRemark" />
            <label for="editedRemark" class="form-label">Remark</label>
          </div>
        } @else {
          <span>{{ receipt.Remark }}</span>
        }

        @if (sharedService.isBranchManager() && receipt.Valid === false) {
          @if (isEditing) {
            <button class="btn btn-danger ms-1" (click)="isEditing = false">
              <i class="fas fa-times"></i>
            </button>
            <button class="btn btn-success ms-1" (click)="updateRemark()">
              <i class="fas fa-check"></i>
            </button>
          } @else {
            <button class="btn btn-warning ms-1 d-none d-md-inline" (click)="editRemark(receipt.Remark)">
              <i class="fas fa-pencil-alt"></i>
            </button>
          }
        }
      </div>

      @if (receipt.CheckerRemark?.length > 0) {
        <div class="text-info fw-bold m-0 p-0"><i class="far fa-comment-dots"></i> : {{ receipt.CheckerRemark }}</div>
      }

      @if (adminView) {
        @if (receipt.SetRemark?.length > 0) {
          <span class="text-success fw-bold m-0 p-0"> <i class="fas fa-comment-dollar"></i> : {{ receipt.SetRemark }} </span>
        }
        @for (tag of receipt.Tags; track tag; let i = $index) {
          <span class="badge text-bg-secondary m-1">{{ tag }} <i class="fas fa-times" style="cursor: pointer" (click)="removeSetTag(i)"></i></span>
        }
        @if (receipt.Tags !== undefined || receipt.SetRemark !== undefined) {
          <button class="btn btn-sm btn-warning" (click)="openEditSetRemark()"><i class="fas fa-pencil-alt"></i></button>
        }
      }

      <div class="d-flex overflow-x-auto">
        <table class="table table-custom">
          <tbody>
            @for (transaction of receipt.TransactionList; track transaction.ID) {
              <tr>
                @if (receipt.Valid === false && sharedService.isBranchManager()) {
                  <td>
                    <button class="btn btn-danger" (click)="deleteTransaction(transaction)">
                      <i class="fas fa-minus"></i>
                    </button>
                  </td>
                }
                <td style="width: 20%">{{ transaction.Date | date: "dd-MM-yyy" }}</td>
                <td style="width: 40%">
                  {{ transaction.Remark }}
                  <ng-template #popContent>
                    @if (transactionCustomerIsReady === false) {
                      <mat-spinner></mat-spinner>
                    } @else {
                      <div class="card mb-2">
                        <div class="card-body" style="cursor: pointer">
                          <h3>{{ transactionCustomer.Name }} ({{ transactionCustomer.ICNumberWithDash }})</h3>
                          <button class="btn btn-info m-1" (click)="goToCustomer(transactionCustomer.ID)" matTooltip="Go To Customer">
                            <i class="fas fa-user"></i>
                          </button>
                          <button class="btn btn-dark m-1" (click)="viewCustomerTransaction(transactionCustomer.Profiles[0].ID, transactionCustomer.CompanyId, transaction)" matTooltip="View Transactions">
                            <i class="fas fa-file-invoice-dollar"></i>
                          </button>
                        </div>
                      </div>
                    }
                  </ng-template>
                  @if ((sharedService.isLoanRelatedType(transaction.Type) || sharedService.isLoanRelatedSubype(transaction.Subtype) || transaction.CustomerID != undefined) && this.sharedService.isExpenseAdmin() === false) {
                    <button class="btn btn-primary btn-sm" [ngbPopover]="popContent" (click)="loadTransactionCustomer(transaction.ID)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                  }
                </td>
                <td style="width: 20%">
                  {{ enums.transactionTypeString[transaction.Type - 1] }}
                  @if ((transaction.Type == enums.EXPENSE || transaction.Type == enums.EXTRAS) && expenseSubtypeList != undefined && dlSubtypeList != undefined) {
                    @if ((this.sharedService.isExpenseAdmin() && transaction.Type == enums.EXPENSE) || (this.sharedService.isBossAccount() && (transaction.Type == enums.EXPENSE || transaction.Type == enums.EXTRAS))) {
                      @if (transaction.Subtype !== undefined) {
                        <button class="btn btn-sm fw-semibold text-info-emphasis bg-info-subtle border-info-subtle" (click)="openManageSubtypeModal(transaction)">
                          {{ subtypeList[transaction.Subtype]?.Name }}
                          <i class="fas fa-pencil-alt"></i>
                        </button>
                      } @else {
                        <button class="btn btn-sm btn-warning" (click)="openManageSubtypeModal(transaction)">
                          <i class="fas fa-folder-plus"></i>
                        </button>
                      }
                    } @else if (transaction.Subtype !== undefined) {
                      <span class="badge fw-semibold text-info-emphasis bg-info-subtle border border-info-subtle fs-6">
                        <small>{{ subtypeList[transaction.Subtype]?.Name }}</small>
                      </span>
                    }
                  }
                </td>
                <td style="width: 20%">RM {{ transaction.Amount | number: "1.0-2" }}</td>
              </tr>
            }
          </tbody>
          <tfoot class="border-dark-subtle">
            <tr>
              @if (receipt.Valid == false && sharedService.isBranchManager()) {
                <th></th>
              }
              <th></th>
              <th></th>
              <th>TOTAL:</th>
              <th>RM {{ calculateTransactionTotal(receipt.TransactionList) | number: "1.0-2" }}</th>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- <hr /> -->

      <div class="row">
        <div class="col d-flex align-items-end justify-content-end">
          @if (receipt.Valid == false && sharedService.isBranchManager()) {
            <button class="btn btn-info" (click)="submitSet()">Submit</button>
            <button class="btn btn-warning ms-1" (click)="addEvidenceForSet()">Add Evidence</button>
          }
          <div>
            @if (receipt.Valid !== false) {
              <div class="d-flex justify-content-end align-items-end mb-2">
                <textarea class="form-control" cols="40" rows="2" required [(ngModel)]="checkerRemark" name="checkerRemark"></textarea>
              </div>
            }

            <div class="d-flex gap-2 justify-content-end align-items-end">
              @if (receipt.Valid === undefined && (sharedService.isAdmin() || sharedService.isBossAccount() || sharedService.isFinance())) {
                <button class="btn btn-outline-success" (click)="setValidation(true)">Validate</button>
              }
              @if (receipt.Valid !== false) {
                <button class="btn btn-outline-danger" (click)="setValidation(false)">Invalidate</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
